import { BarringTypes, Barring } from '~/barrings/model/barring.model'

export const barringLiteralsByType = {
  [BarringTypes.THEFT_BLOCK]: 'Robo',
  [BarringTypes.LOSS_BLOCK]: 'Pérdida',
  [BarringTypes.WEAR_AND_TEAR_BLOCK]: 'Deterioro',
  [BarringTypes.FRAUD_BLOCK]: 'Fraude',
  [BarringTypes.RETURNED_INVOICE_BLOCK]: 'Factura devuelta',
  [BarringTypes.RISK_BLOCK]: 'Riesgo',
}

export const getBarringName = (barring: Barring) => barringLiteralsByType[barring.id] || barring.id
